import Brightness4Icon from "@mui/icons-material/Brightness4";
import PropTypes from "prop-types";
import Brightness7Icon from "@mui/icons-material/Brightness7";
import { IconButton } from "@mui/material";
import { useDarkModeData } from "src/context/DarkModeContext";

export default function DarkModeButton({ color = "inherit" }) {
  const { darkMode, doSetDarkMode } = useDarkModeData();

  return (
    <IconButton
      sx={{ ml: 1 }}
      onClick={() => doSetDarkMode(!darkMode)}
      aria-label="Dark mode"
      color={color}>
      {darkMode ? <Brightness7Icon /> : <Brightness4Icon />}
    </IconButton>
  );
}

DarkModeButton.propTypes = {
  color: PropTypes.string,
};
